import React from 'react';
import { Suspense } from 'react';
import { ErrorBoundary } from '@SharedScripts/ErrorBoundary';
import { LottieAnimationProps } from './LottieAnimation';
import { lazyWithPreload } from '../../helpers/preloadComponent';

const LottieAnimation = lazyWithPreload(() => import('./LottieAnimation').then((module) => ({ default: module.LottieAnimation })));

const LazyLottieAnimation = (props: LottieAnimationProps) => {
  return <ErrorBoundary fallback={<div></div>}>
    <Suspense>
      <LottieAnimation {...props} />
    </Suspense>
  </ErrorBoundary>;
};

export default LazyLottieAnimation;
export {
  LottieAnimation
};